import {Component, effect, inject, input, signal} from '@angular/core';
import {DecimalPipe, SlicePipe} from "@angular/common";
import {BluetoothSvgComponent, Status} from "src/app/presentation/common/icons/bluetooth-svg/bluetooth-svg.component";
import {rssisToColorClass} from 'src/app/domain/samples/rssi/rssi';
import {RssiStore} from 'src/app/domain/samples/rssi/rssi.store';
import {AggregatedDeviceStateStore} from 'src/app/domain/devices/aggregated-state/aggregated-device-state.store';
import {batteryIcon, batteryLevelColor} from 'src/app/domain/assets/battery/battery';
import {
  animalLowVoltageThreshold,
  animalMidVoltageThreshold
} from 'src/app/presentation/common/asset-details.component';
import {timeAgo} from 'src/app/domain/util/timestamps/timestamps';
import {isEqualToOrYoungerThanOffset} from 'src/app/app.config';
import {oneHour} from 'src/app/presentation/common/globals';

@Component({
  selector: 'app-scanner',
  imports: [
    BluetoothSvgComponent,
    DecimalPipe,
    SlicePipe
],
  templateUrl: './scanner.component.html',
  styleUrl: './scanner.component.css'
})
export class ScannerComponent {

  deviceId = input.required<string>();

  status = signal(Status.ONLINE);

  statusMessage = signal('Last seen: ?');
  statusMessageColorClass = signal('color-danger');

  batteryVoltage = signal<number | undefined>(undefined)
  batterLevelColor = signal('color-primary-information');
  batteryIcon = signal('fa-solid fa-battery-empty');

  rssiColor = signal<string | undefined>(undefined);

  private aggregatedDeviceStateStore = inject(AggregatedDeviceStateStore);
  private rssiStore = inject(RssiStore);

  constructor() {
    effect(() => {
      const deviceId = this.deviceId();
      if (!deviceId) return;

      const rssiPerGateway = this.rssiStore.deviceIdToRssiPerGateway().get(deviceId);
      this.rssiColor.set(rssisToColorClass(rssiPerGateway))
    });

    effect(() => {
      const deviceId = this.deviceId();
      if (!deviceId) return;

      const aggregatedDeviceState = this.aggregatedDeviceStateStore.entityMap()[deviceId]
      if (!aggregatedDeviceState) return;

      this.batteryVoltage.set(aggregatedDeviceState.batteryVoltage);
      this.batterLevelColor.set(batteryLevelColor(aggregatedDeviceState.batteryVoltage, animalLowVoltageThreshold, animalMidVoltageThreshold));
      this.batteryIcon.set(batteryIcon(aggregatedDeviceState.batteryVoltage, animalLowVoltageThreshold, animalMidVoltageThreshold));

      const lastSeenByGatewayAt = aggregatedDeviceState.lastSeenByGatewayAt;
      this.statusMessage.set(`Last seen: ${timeAgo(lastSeenByGatewayAt)}`);

      if (lastSeenByGatewayAt !== undefined && isEqualToOrYoungerThanOffset(lastSeenByGatewayAt, oneHour)) {
        this.statusMessageColorClass.set("color-primary-information");
        this.status.set(Status.ONLINE);
      } else {
        this.statusMessageColorClass.set("color-danger");
        this.status.set(Status.OFFLINE);
      }
    });
  }
}
